import * as tslib_1 from "tslib";
import { FieldType } from '@ngx-formly/core';
var FormlyFieldStringInterpolateRichTextComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FormlyFieldStringInterpolateRichTextComponent, _super);
    function FormlyFieldStringInterpolateRichTextComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyFieldStringInterpolateRichTextComponent;
}(FieldType));
export { FormlyFieldStringInterpolateRichTextComponent };
